import React from 'react';

const FaCircleBoxesIcon = ({
  backgroundColor = process.env.REACT_APP_KEYCLOAK_CLIENT_ID === 'financeiro-front' ? '#171b54' : '#3DA4BC',
  color = '#fff',
  size = 30,
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 19 19">
    <g id="Grupo_1748" data-name="Grupo 1748" transform="translate(-845 -19)">
      <g id="Elipse_7" data-name="Elipse 7" transform="translate(845 19)" fill={color} stroke={color} strokeWidth="1">
        <circle cx="9.5" cy="9.5" r="9.5" stroke="none" />
        <circle cx="9.5" cy="9.5" r="9" fill="none" />
      </g>
      <path
        id="Icon_awesome-cubes"
        data-name="Icon awesome-cubes"
        d="M12.883,8l-2.547-.954V4.187A.949.949,0,0,0,9.719,3.3L7.082,2.31a.938.938,0,0,0-.667,0L3.778,3.3a.949.949,0,0,0-.617.889V7.048L.614,8A.95.95,0,0,0,0,8.891v2.9a.95.95,0,0,0,.525.849l2.637,1.318a.944.944,0,0,0,.849,0L6.75,12.59l2.74,1.371a.944.944,0,0,0,.849,0l2.637-1.318a.95.95,0,0,0,.525-.849v-2.9A.949.949,0,0,0,12.883,8ZM9.439,7.069,7.2,7.91v-1.8l2.241-.976ZM4.061,4.15,6.75,3.143,9.439,4.15v.016L6.75,5.257,4.061,4.166Zm2.215,7.675L4.034,12.946V10.86L6.275,9.837Zm0-2.953L3.586,9.964.9,8.872V8.857L3.586,7.849,6.275,8.857ZM12.6,11.825l-2.241,1.121V10.86L12.6,9.837Zm0-2.953L9.914,9.964,7.225,8.872V8.857L9.914,7.849,12.6,8.857Z"
        transform="translate(848 20.252)"
        fill={backgroundColor}
      />
    </g>
  </svg>
);

export default FaCircleBoxesIcon;
